<template src="./index.html" />
<script>
import {
  mapState, mapActions,
} from 'vuex';
export default {
  name: 'LibraryEditingModal',
  data: () => ({
    // eslint-disable-next-line
    emailRegex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
    dialog: false,
    errors: false,
    libraryObjectLinks: [
      {
        title: 'Edit library', icon: 'mdi-table-edit', value: 'editLibrary', link: '',
      },
      {
        title: 'View master library', icon: 'mdi-briefcase', value: 'viewMasterLibrary', link: '',
      },
      {
        title: 'View collections', icon: 'mdi-folder-account', value: 'viewCollections', link: '',
      },
      {
        title: 'Submit new product', icon: 'mdi-folder-plus', value: 'submitNewProduct', link: '',
      },
      {
        title: 'Submit equal', icon: 'mdi-marker-check', value: 'submitEqual', link: '',
      },
    ],
  }),
  computed: {
    ...mapState(['showLibraryEditingModal', 'libraryLinks']),
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.clearCreateForm();
      }
    },
    showLibraryEditingModal() {
      if (!this.dialog) {
        this.dialog = true;
        this.getAdminLibraryLinks();
      } else {
        this.dialog = false;
      }
    },
    libraryLinks(val) {
      if (val) {
        this.libraryObjectLinks.forEach((item, index) => {
          this.libraryObjectLinks[index].link = this.libraryLinks[item.value];
        });
      }
    },
  },
  methods: {
    ...mapActions(['getAdminLibraryLinks', 'updateAdminLibraryLinks']),
    checkUrl(link) {
      return this.errors && (!link || !link.match(this.emailRegex));
    },
    async updateLibraryLinks() {
      this.errors = true;
      if (this.libraryObjectLinks.every(item => item.link
        && item.link.match(this.emailRegex))) {
        const jsonToSend = {
        };
        this.libraryObjectLinks.forEach((item) => {
          jsonToSend[item.value] = item.link;
        });
        this.updateAdminLibraryLinks(jsonToSend);
      }
    },
    clearCreateForm() {
      this.libraryObjectLinks.forEach((item, index) => {
        this.libraryObjectLinks[index].link = '';
      });
      this.errors = false;
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
